import React, { useState } from "react"
import PropTypes from "prop-types"
import { useHistory } from "react-router-dom"

import CanadaAmenities from "../SchedulePages/Canada/Amenities"
import ModuleTitle from "../../atoms/SchedulePages/ModuleTitle"
import TabNavbarLayout from "../../layouts/TabNavbarLayout"
import { CanadaLocations } from "../SchedulePages/Canada/pickup-locations"
import { BookNow } from "../SchedulePages/BookNow"
import FAQBox from "../SchedulePages/FAQ"
import acbus from "../../../media/acbus.png"

import "../SchedulePages/SchedulePage.desktop.scss"
import "../SchedulePages/SchedulePage.mobile.scss"
import "./CanadaLanding.scss"
import { English } from "./metadata"
import { French } from "./metadata-fr"

const CanadaLanding = () => {
  const [content, setContent] = useState(English)

  const switchLanguage = () => {
    if (content.english) {
      setContent(prev => ({
        ...prev,
        ...French
      }))
    } else {
      setContent(prev => ({
        ...prev,
        ...English
      }))
    }
  }

  return (
    <div className="home-page">
      <TabNavbarLayout
        renderCanadaMenu={true}
        renderTabs={false}
        switchLanguage={switchLanguage}
        isFrench={content.french}
        beforeTab={() => (
          <>
            <div className="custom-header-banner">
              <p className="custom-header-text">
                {content.meta.hero.title}
              </p>
              <p className="custom-header-subtite">
                {content.meta.hero.subtitle}
              </p>
            </div>
          </>
        )}
        render={() => (
          <>
            <div className="schedule-page">
              <div className="canada-lead">
                <div className="canada-lead-text">
                  <h4>{content.meta.header.title}</h4>
                  {content.meta.header.subtitle}
                </div>
                <img className="canada-bus" src={acbus} alt="" />
              </div>
              <ModuleTitle title={content.options.title} />
              <div className="schedule-page-schedules-container">
                <div className="best-options">
                  {content.options.options.map((option, index) => {
                    return (
                      <>
                        <div className="best-option-container" key={index}>
                          <img src={option.logo} />
                          <div className="best-option">
                            <div className="best-option-title">
                              <h4>{option.title}</h4>
                              <p>{option.subtitle}</p>
                            </div>
                            <div className="best-option-benefits">
                              <b>{option.benefits.title}</b>
                              <ul>
                                {option.benefits.list.map((item, index) => {
                                  return <li key={index}>{item}</li>
                                })}
                              </ul>
                              <b>{option.bestif.title}</b>
                              <ul>
                                {option.bestif.list.map((item, index) => {
                                  return <li key={index}>{item}</li>
                                })}
                              </ul>
                            </div>
                            <BookNow title={option.button.title} url={option.button.link} />
                          </div>
                        </div>
                      </>
                    )
                  })}
                </div>
              </div>

              <ModuleTitle title={content.meta.titles.locations} />
              <div className="locations">
                {CanadaLocations.map((location, index) => {
                  return (
                    <img
                      key={index}
                      src={location.image}
                      onClick={() => {
                        window.location.href = location.path
                      }}
                      alt=""
                    />
                  )
                })}
              </div>
              <ModuleTitle title={content.meta.titles.amenities} />
              <CanadaAmenities showtext={false} amenities={content.amenities} />
              <FAQBox phone="+12494920941" phone_text="(249) 492-0941" phoneOnly={true} />
            </div>
          </>
        )}
      />
    </div>
  )
}

export default CanadaLanding

CanadaLanding.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
}
